export function CopyPasteGeneric (pEditor, pCopyPaste)
{
  var onPasteDoTM = null;
  
  
  this.onCopy = (e) =>
  {
    BEditor.onCopy(e, pEditor.iFrame);
  };


  this.onPaste = (e) =>
  {
    let currentRange = pEditor.range.getCurrent(true),
        pasteDataText,
        pasteDataLength,
        tm = 100;

    if (onPasteDoTM) clearTimeout(onPasteDoTM);

    if (BEditor.isLocalClipboard)
    {
      pCopyPaste.removeSystemComponents();
      pEditor.helpers.restoreEditorEntities();
      return true;
    }

    try
    {
      if (BEditor.browser.isIE)
      {
        pasteDataText = null;
        pasteDataLength = null;
      }
      else
      {
        if (e.clipboardData.types.contains('text/html'))
        {
          pasteDataLength = e.clipboardData.getData('text/html').length;
        }
        else if (e.clipboardData.types.contains('text/plain'))
        {
          pasteDataLength = e.clipboardData.getData('text/plain').length * 1.5;
        }
      }
    }
    catch (err)
    {
      pasteDataText = null;
      pasteDataLength = null;
    }

    pEditor.contentChecker.isStopCheckContentChanged = true;
    pEditor.undoRedo.isStopSaveUndo = true;
    pEditor.contentChecker.isPasteEvent = 1;
    BEditor.EditorsManager.showPageShadingContainer(true, 'Cleaning HTML...', 1000);

    currentRange.insertNode(currentRange.createContextualFragment(`<abbr data-wawebkitcopyendpointer="1">&nbsp;</abbr>`));
    pEditor.setWaContentMarker();

    if (pasteDataLength)
    {
      tm = Math.round(pasteDataLength / 200);
      tm = ((tm < 100) ? 100 : ((tm > 300) ? 300 : tm));
    }

    onPasteDoTM = setTimeout(onPasteDo, tm);
  };


  function onPasteDo ()
  {
    let currentRange = pEditor.range.getCurrent(),
        currentContentLength,
        simplifyFormattingRet,
        rawHTML,
        pasteHTML,
        firstPastedElement = pEditor.iFrameDoc.body.querySelector(':not([data-wacontent])'),
        copyMarker = (firstPastedElement ? pEditor.iFrameDoc.body.querySelector('[data-wacopycontent]') : true),
        isFullContent = false;

    pCopyPaste.removeCopyMarker();

    if (!copyMarker)
    {
      if (!pEditor.iFrameDoc.body.querySelector('ABBR[data-wawebkitcopyendpointer]'))
      {
        let lastPastedElement = pEditor.iFrameDoc.body.querySelector(':not([data-wacontent])');

        if (lastPastedElement)
        {
          let nextSibling = lastPastedElement;

          do
          {
            nextSibling = nextSibling.nextSibling;

            if (!nextSibling || (nextSibling.nodeType === 1 && nextSibling.hasAttribute('data-wacontent')))
            {
              lastPastedElement.insertAdjacentHTML('afterend', `<abbr data-wawebkitcopyendpointer="1" data-wacontent="${pEditor.waContentMarkerCounter++}" data-wacontenttag="ABBR">&nbsp;</abbr>`);
              break;
            }

            if (nextSibling.nodeType === 1)
            {
              lastPastedElement = nextSibling;
            }
          }
          while (nextSibling);
        }
      }

      rawHTML = pEditor.iFrameDoc.body.innerHTML;
      currentContentLength = rawHTML.length;

      pasteHTML = rawHTML;
      isFullContent = true;

      simplifyFormattingRet = pCopyPaste.normalizer.normalize(pasteHTML, {'isClearEmptyTags': true, 'isWaContentMarkers': true});
      pasteHTML = simplifyFormattingRet.htmlContent;

      if (simplifyFormattingRet.isSimplify)
      {
        if (!isFullContent)
        {
          currentRange.deleteContents();
          pEditor.contentCleaner.removeEmptyP();

          if (pEditor.iFrameDoc.body.querySelector(':not([data-wacontent])'))
          {
            simplifyFormattingRet = pCopyPaste.normalizer.normalize(rawHTML, {'isClearEmptyTags': true, 'isWaContentMarkers': true});
            pasteHTML = simplifyFormattingRet.htmlContent;
            isFullContent = true;
          }
        }

        if (pEditor.style.normalizer.checkMsHTML(rawHTML))
        {
          rawHTML = pEditor.style.normalizer.clearMsHTML(rawHTML);
        }

        //pEditor.undoRedo.saveUndoDo(false, rawHTML);
        pCopyPaste.showAutoCleaningMessage();

        if (isFullContent)
        {
          pEditor.iFrameDoc.body.innerHTML = pasteHTML;
        }
        else
        {
          currentRange.insertNode(currentRange.createContextualFragment(`<input type="hidden" data-wacontent="${pEditor.waContentMarkerCounter++}" data-wacontenttag="INPUT" data-wapastepointmarker="1">`));
          pEditor.iFrameDoc.body.innerHTML = pEditor.iFrameDoc.body.innerHTML.replace(/<input[^>]+data-wapastepointmarker[^>]+>/i, pasteHTML);
        }

        setTimeout(() => pEditor.contentChecker.onPasteHandler(setCursorPointer), 100);
      }
      else
      {
        setCursorPointer(true);
        setTimeout(setCursorPointer, 1000);
        pEditor.contentChecker.afterClearCallBack = setCursorPointer;
      }
    }
    else
    {
      setCursorPointer(true);
      setTimeout(setCursorPointer, 1000);
      pEditor.contentChecker.afterClearCallBack = setCursorPointer;
    }

    if (copyMarker || !simplifyFormattingRet.isSimplify)
    {
      pCopyPaste.removeSystemComponents();
      pEditor.helpers.restoreEditorEntities();
      pEditor.undoRedo.isStopSaveUndo = false;
      pEditor.contentChecker.isStopCheckContentChanged = false;
      pEditor.contentChecker.isPasteEvent = 0;
      BEditor.EditorsManager.hidePageShadingContainer();
    }
  }


  function setCursorPointer (isNotRemove)
  {
    let i,
        currentSelection = pEditor.range.selection.getCurrent(true),
        currentRange = pEditor.range.getCurrent(true),
        elements,
        element = pEditor.iFrameDoc.body.querySelector('ABBR[data-wawebkitcopyendpointer]');

    if (element)
    {
      currentSelection.removeAllRanges();
      currentRange.setEndBefore(element);
      currentRange.setStartBefore(element);
      currentSelection.addRange(currentRange);
    }

    if (!isNotRemove)
    {
      pEditor.contentChecker.afterClearCallBack = setCursorPointer;

      elements = pEditor.iFrameDoc.body.querySelectorAll('ABBR[data-wawebkitcopyendpointer]');

      for (i = elements.length; i--;)
      {
        if (elements[i] && elements[i].parentNode)
        {
          let parentElement = elements[i].parentNode;
          parentElement.removeChild(elements[i]);

          if (parentElement.nodeName === 'P' && parentElement.innerHTML.replace(/\s*/g, '') === '' && parentElement.parentNode)
          {
            parentElement.parentNode.removeChild(parentElement);
          }
        }
      }
    }
  }
}